<template>
  <div v-if="avatars.length > 0">
    <header-game :close="false" :back="true"></header-game>
    <div class="container container--full">
      <div class="home avatar">
        <div class="select-avatar">
          <div class="select-avatar__title">
            <h3>{{$t("selectAvatar.title")}}</h3>
          </div>
          <flickity ref="flickity" :options="flickityOptions" class="select-avatar__avatars">
            <template v-for="(avatar, indexAvatar) in avatars">
              <div class="carousel-cell select-avatar__avatars__avatar" :key="indexAvatar">
                <img :src="getUrlAvatar(avatar.avatar)" alt="">
              </div>
            </template>
          </flickity>
          <button class="button button--white" @click="goToGame()" :disabled="submitted">
            <template v-if="!submitted">
              {{$t('selectAvatar.goToGame')}}
            </template>
            <template v-else>
              {{$t('selectAvatar.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
            </template>
          </button>
        </div>
      </div>
    </div>
    <footer-sponsor></footer-sponsor>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import persistentData from '@/plugins/persistentData'
import HeaderGame from '@/components/Header/Game.vue'
import FooterSponsor from '@/components/Footer/Sponsor.vue'
import Flickity from 'vue-flickity'

export default {
  components: {
    HeaderGame,
    FooterSponsor,
    Flickity
  },
  computed: {
    ...mapState({
      avatars: state => state.InfoModule.avatars
    })
  },
  data() {
    return {
      avatarId: '',
      flickityOptions: {
        initialIndex: 1,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        lazyLoad: true,
        resize: true
      },
      submitted: false
    }
  },
  mounted() {
    const self = this

    if (self.avatars.length === 0) {
      self.$store.dispatch('getAvatars', { id: self.$route.params.idTeam })
        .then(() => {
          self.avatarId = self.avatars[1].id
          self.$refs.flickity.on('change', self.changeAvatar)
        })
    } else {
      self.avatarId = self.avatars[1].id
      setTimeout(() => {
        self.$refs.flickity.on('change', self.changeAvatar)
      }, 0)
    }
  },
  methods: {
    async goToGame() {
      this.submitted = true
      const configActions = await this.$store.dispatch("getClientConfig")
      const params = { 
        gameId: this.$route.params.id,
        teamId: this.$route.params.idTeam,
        avatarId: this.avatarId,
        joinGame: !configActions.actions.inflable
      }
      // this.$store.dispatch('soundSilence')
      persistentData.setData(`game-${params.gameId}`, params, true)
      this.$router.push(`/game/${params.gameId}`)
      setTimeout(() => {
        this.submitted = false
      }, 1000)
    },
    getUrlAvatar(avatar) {
      return `${process.env.VUE_APP_CDN_URL_AVATARS}${avatar}`
    },
    changeAvatar(indexAvatar) {
      this.avatarId = this.avatars[indexAvatar].id
    }
  },
  watch: {
    selectGame: function() {
      // Verify status game
      this.$router.push(`/home/games`)
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/_variables';

  .avatar {
    padding: 80px 0;
  }

  .container--full {
    width: auto!important;
  }

  .select-avatar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;

    &__title {
      text-align: center;

      h3 {
        margin: 0;
        color: $white;
        font-weight: 700;
        @include font-settings(kilo, base);
      }
    }

    &__avatars {
      display: block;
      margin: $margin-mega 0;
      width: 100%;

      &__avatar {
        width: 320px;
        height: 400px;
        opacity: .4;
        transition: transform .4s ease-in-out, opacity .4s ease-in-out;
        display: flex;
        transform: scale(1);
        justify-content: center;
        flex-direction: column;

        &.is-selected {
          opacity: 1;
          transform: scale(1.5);
          width: 340px;
          margin-left: -10px;
          // width: 480px;
          // transform: scale(1);
        }

        img {
          display: block;
          max-height: 100%;
          margin: 0 auto;
          max-width: 100%;
        }
      }
    }

    .flickity-page-dots {
      
      .dot {
        background: $white;
      }
    }

    .flickity-button {
      background: none;
      border: none;
      bottom: auto;

      &-icon {
        fill: $white;
      }

      @media (min-width: $break-sm) {

        &.previous {
          left: 25%;
        }
        
        &.next {
          right: 25%;
        }
      }

      @media (min-width: $break-md) {

        &.previous {
          left: 33%;
        }
        
        &.next {
          right: 33%;
        }
      }
    }

    button {
      position: absolute;
      bottom: 120px;
      border: 1px solid $lightblue;
    }
  }
</style>